import { ThoughtsBoard } from '@/components/thoughts/thoughts-board';
import React from 'react';
import { useParams } from 'react-router-dom';

/**
 * ThoughtsPage component
 *
 * This page provides a clean, modern thoughts interface for capturing
 * ideas, concepts, and other thoughts without requiring immediate categorization.
 */
const ThoughtsPage: React.FC = () => {
  const { projectId } = useParams<{ projectId: string }>();
  return <ThoughtsBoard projectId={projectId || ''} />;
};

export default ThoughtsPage;
